export const Adj = [
  "가냘픈",
  "가는",
  "가엾은",
  "가파른",
  "같은",
  "거센",
  "거친",
  "검은",
  "게으른",
  "게을러빠진",
  "게을러터진",
  "고달픈",
  "고른",
  "고마운",
  "고운",
  "고픈",
  "곧은",
  "괜찮은",
  "구석진",
  "굳은",
  "굵은",
  "귀여운",
  "그런",
  "그른",
  "그리운",
  "기다란",
  "기쁜",
  "긴",
  "깊은",
  "깎아지른",
  "깨끗한",
  "나쁜",
  "나은",
  "난데없는",
  "날랜",
  "날카로운",
  "낮은",
  "너그러운",
  "너른",
  "널따란",
  "넓은",
  "네모난",
  "노란",
  "높은",
  "누런",
  "눅은",
  "느닷없는",
  "느린",
  "늦은",
  "다른",
  "더러운",
  "더운",
  "덜된",
  "동그란",
  "돼먹잖은",
  "된",
  "둥그런",
  "둥근",
  "뒤늦은",
  "드문",
  "딱한",
  "때늦은",
  "뛰어난",
  "뜨거운",
  "막다른",
  "많은",
  "매운",
  "먼",
  "멋진",
  "메마른",
  "메스꺼운",
  "모난",
  "못난",
  "못된",
  "못생긴",
  "무거운",
  "무딘",
  "무른",
  "무서운",
  "미끈미끈한",
  "미운",
  "바람직스러운",
  "반가운",
  "밝은",
  "밤늦은",
  "보드라운",
  "보람찬",
  "보잘것없는",
  "부드러운",
  "부른",
  "붉은",
  "비싼",
  "빠른",
  "빨간",
  "뻘건",
  "뼈저린",
  "뽀얀",
  "뿌연",
  "새로운",
  "서툰",
  "섣부른",
  "설운",
  "성가신",
  "센",
  "수다스러운",
  "수줍은",
  "쉬운",
  "스스러운",
  "슬픈",
  "시원찮은",
  "싫은",
  "싼",
  "쌀쌀맞은",
  "쏜살같은",
  "쓰디쓴",
  "쓰린",
  "쓴",
  "아니꼬운",
  "아닌",
  "아름다운",
  "아쉬운",
  "아픈",
  "안된",
  "안쓰러운",
  "안타까운",
  "않은",
  "알맞은",
  "약빠른",
  "약은",
  "얇은",
  "얕은",
  "어두운",
  "어려운",
  "어린",
  "언짢은",
  "엄청난",
  "없는",
  "여문",
  "열띤",
  "예쁜",
  "올바른",
  "옳은",
  "외로운",
  "우스운",
  "의심쩍은",
  "이른",
  "익은",
  "있는",
  "작은",
  "잘난",
  "잘빠진",
  "잘생긴",
  "재미있는",
  "적은",
  "젊은",
  "점잖은",
  "조그만",
  "좁은",
  "좋은",
  "주제넘은",
  "줄기찬",
  "즐거운",
  "지나친",
  "지혜로운",
  "질긴",
  "짓궂은",
  "짙은",
  "짠",
  "짧은",
  "케케묵은",
  "큰",
  "탐스러운",
  "턱없는",
  "푸른",
  "하나같은",
  "한결같은",
  "흐린",
  "희망찬",
  "흰",
  "힘겨운",
  "힘찬",
];
export const Noun = [
  "가공품",
  "가나다순",
  "가나다차례",
  "가능성",
  "가등기",
  "가매장",
  "가맹점",
  "가설법",
  "가속기",
  "가시집",
  "가요제",
  "가정법",
  "가해자",
  "각성제",
  "간소화",
  "갈비탕",
  "감시인",
  "감탄사",
  "갑각류",
  "개떡",
  "거주자",
  "거짓말쟁이",
  "건포도",
  "결혼식",
  "겹문장",
  "겹박자",
  "겹받침",
  "겹씨방",
  "경기장",
  "경력자",
  "경마장",
  "경비행기",
  "경쟁심",
  "경쟁자",
  "경험담",
  "계약자",
  "고립어",
  "고아원",
  "곡면체",
  "곤충학",
  "골동품",
  "공포증",
  "과거형",
  "과학자",
  "관광지",
  "교도소",
  "교사범",
  "교육자",
  "교착어",
  "교향곡",
  "구각형",
  "구경꾼",
  "구름층",
  "구매자",
  "구세대",
  "구자라트어",
  "구한국",
  "구한말",
  "국경일",
  "군소리",
  "군주국",
  "굴절어",
  "그리스어",
  "그리스인",
  "기상학",
  "기역니은디귿순",
  "기역니은디귿차례",
  "기역니은순",
  "기회주의자",
  "기후대",
  "남극해",
  "냉면",
  "넓이",
  "노부부",
  "늦가을",
  "늦겨울",
  "늦더위",
  "늦봄",
  "늦서리",
  "늦여름",
  "다각형",
  "다복솔",
  "단무지",
  "대괄호",
  "대구법",
  "대규모",
  "대기권",
  "대도시",
  "대보름",
  "대서양",
  "대유행",
  "대장경",
  "대접전",
  "대지진",
  "대학교",
  "대호지",
  "도둑질",
  "도서관",
  "동시범",
  "등거리",
  "등산로",
  "등산화",
  "떡잎",
  "마구간",
  "막내둥이",
  "맏딸",
  "맏아들",
  "말레이어",
  "말벌",
  "말썽꾸러기",
  "망원경",
  "맨발",
  "모직물",
  "모험가",
  "무기수",
  "무뢰한",
  "무신론",
  "무신론자",
  "물집",
  "미개척",
  "미성년",
  "미완성",
  "미터법",
  "민소매",
  "바느질",
  "반대론",
  "반대설",
  "반만년",
  "반바지",
  "반소설",
  "반자성",
  "반중력",
  "발원지",
  "방송사",
  "배급처",
  "배설물",
  "배우자",
  "번화가",
  "범죄인",
  "범죄자",
  "베트남어",
  "변신술",
  "별안간",
  "보신탕",
  "북극해",
  "북해도",
  "분수령",
  "불가능",
  "불구자",
  "비교급",
  "비망록",
  "비속어",
  "비정상",
  "비행기",
  "사각형",
  "사무소",
  "사진기",
  "사치품",
  "사형수",
  "사회자",
  "살인범",
  "살인자",
  "삼각형",
  "생산품",
  "성층권",
  "세균학",
  "소유물",
  "소책자",
  "손질",
  "송별식",
  "수감자",
  "수고양이",
  "수꿩",
  "수말",
  "수사법",
  "수사슴",
  "수소",
  "수영장",
  "신경계",
  "신세대",
  "신축성",
  "실안개",
  "싸움질",
  "쌍둥이",
  "아낙네",
  "알탕",
  "암꿩",
  "암말",
  "암사슴",
  "애국심",
  "애벌레",
  "애호박",
  "양동이",
  "양서류",
  "양의사",
  "양초",
  "양파",
  "어조사",
  "어지럼증",
  "어패류",
  "얼간이",
  "연구소",
  "연금술",
  "연주회",
  "예술가",
  "오각형",
  "외곬",
  "외국인",
  "외기권",
  "외발",
  "외아들",
  "운동장",
  "웃옷",
  "웃음",
  "원말",
  "유대인",
  "유람선",
  "유렵기",
  "은유법",
  "음식물",
  "음식점",
  "음악가",
  "음악회",
  "이물감",
  "인도양",
  "임대인",
  "임차인",
  "자기장",
  "작곡가",
  "잔병",
  "잔뿌리",
  "잠",
  "잠꾸러기",
  "잡귀신",
  "잡상인",
  "잡생각",
  "잡소리",
  "잡풀",
  "장담",
  "재발표",
  "재산가",
  "재판관",
  "재판권",
  "전문가",
  "전자기파",
  "점층법",
  "접두사",
  "접속법",
  "정거장",
  "정류장",
  "제삼자",
  "제외지",
  "제화공",
  "조직체",
  "죄책감",
  "중국어",
  "증후군",
  "지상파",
  "지휘권",
  "진보라",
  "진분수",
  "진통제",
  "진화론",
  "진화설",
  "집합론",
  "참뜻",
  "참살",
  "창작품",
  "창호지",
  "천체력",
  "초가을",
  "초겨울",
  "초여름",
  "축지법",
  "출판물",
  "출판사",
  "춤꾼",
  "치료제",
  "칼미크족",
  "칼집",
  "타당성",
  "탈영자",
  "태평양",
  "투르크멘어",
  "투표자",
  "파출소",
  "파충류",
  "패거리",
  "평면도",
  "포도주",
  "포유류",
  "폴란드어",
  "표현법",
  "풋고추",
  "풋콩",
  "풍유법",
  "프랑스어",
  "학술",
  "학술원",
  "한국어",
  "한마을",
  "항공기",
  "해산물",
  "허탈감",
  "형태소",
  "혼성어",
  "혼종어",
  "화강암",
  "화물선",
  "화장실",
  "화장품",
  "활유법",
  "후임자",
  "휘발유",
  "흉악범",
  "희석률",
];
export const NounEng = [
  "wealth",
  "setting",
  "contribution",
  "fortune",
  "investment",
  "strategy",
  "virus",
  "dad",
  "cookie",
  "dinner",
  "assistant",
  "instance",
  "security",
  "replacement",
  "resource",
  "statement",
  "quantity",
  "construction",
  "movie",
  "recommendation",
  "media",
  "family",
  "news",
  "reception",
  "computer",
  "basket",
  "proposal",
  "location",
  "ladder",
  "leader",
  "video",
  "road",
  "death",
  "departure",
  "year",
  "memory",
  "philosophy",
  "manager",
  "month",
  "society",
  "outcome",
  "studio",
  "conversation",
  "environment",
  "feedback",
  "bath",
  "series",
  "classroom",
  "ambition",
  "efficiency",
]
